import { reactive, ref, watch } from 'vue';
import type { TeamAthlete, TeamAthleteProfile, MinimalAthleteForPosition } from '@/types/athletes';

export interface UseChangeEmailDialogState {
  isOpen: boolean;
  athlete: MinimalAthleteForPosition | TeamAthlete | TeamAthleteProfile | null;
  email: string | null;
}

const DEFAULT_STATE: UseChangeEmailDialogState = {
  isOpen: false,
  athlete: null,
  email: null,
};

const getDefaultState = () => ({ ...DEFAULT_STATE });

const state = reactive<UseChangeEmailDialogState>(getDefaultState());

function resetState() {
  Object.assign(state, getDefaultState());
}

const isRendered = ref<boolean>(false);

watch(() => state.isOpen, (isOpen) => {
  if (isOpen && !isRendered.value) isRendered.value = true;
  if (!isOpen) resetState();
});

export function useChangeEmailDialog() {
  async function open(athlete: TeamAthlete | TeamAthleteProfile | MinimalAthleteForPosition, email: string | null) {
    state.isOpen = true;
    state.athlete = athlete;
    state.email = email;
  }

  return {
    state,
    isRendered,
    resetState,
    open,
  };
}
